import { Injectable } from '@angular/core';
import { DataService } from 'src/app/shared/session';

@Injectable({
  providedIn: 'root'
})
export class AccesoUsuarioService {

  constructor(private dataService: DataService) { }

  private saveAccesoUsuarioUrl: string = 'accesoUsuario/save';

  guardarAccesoUsuario(idAplicacion: number, idNivelAcceso: number, idEntidad: number, idRol: number, idUsuario: number): any {
    let parameters: string;
    parameters = JSON.stringify({
      idAplicacion: idAplicacion,
      idNivelAcceso: idNivelAcceso,
      idEntidad: idEntidad,
      idRol: idRol,
      idUsuario: idUsuario,
    });
    this.dataService.set(this.saveAccesoUsuarioUrl);
    return this.dataService.execPostJson(parameters);
  }
}
